import { Component, inject } from '@angular/core';
import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '../../../services/translation/translate.pipe';
import { CustomBonusService } from '../../../services/custom-bonus.service';

@Component({
  selector: 'app-bonus-boost',
  imports: [
    TranslatePipe,
    NgStyle,
    RouterLink,
  ],
  templateUrl: './bonus-boost.component.html',
  styleUrl: './bonus-boost.component.scss',
})
export class BonusBoostComponent {

  public customBonus = inject(CustomBonusService);

}
